import React, { useState } from 'react';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Set the URL to /login while this page is showing
  React.useEffect(() => {
    if (window.location.pathname !== '/login') {
      window.history.replaceState(null, '', '/login');
    }
  }, []);

  const ERROR_MESSAGES = {
    'auth/user-not-found':         'No account found with that email.',
    'auth/wrong-password':         'Incorrect password.',
    'auth/invalid-credential':     'Invalid credentials.',
    'auth/invalid-email':          'Invalid email address.',
    'auth/too-many-requests':      'Too many attempts. Wait a few minutes.',
    'auth/user-disabled':          'This account has been disabled.',
    'auth/network-request-failed': 'Network error. Check your connection.',
  };

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const auth = getAuth();
      await signInWithEmailAndPassword(auth, email.trim(), password);
      // Restore the root URL so the app loads cleanly after auth state updates
      window.history.replaceState(null, '', '/');
      // onAuthStateChanged in App.js will re-render the app automatically.
    } catch (err) {
      setError(ERROR_MESSAGES[err.code] || `Sign-in failed (${err.code || 'unknown'})`);
      setLoading(false);
    }
  }

  return (
    <div style={styles.body}>
      <div style={styles.card}>
        <div style={styles.icon}>🔐</div>
        <h1 style={styles.h1}>Executive Assistant</h1>
        <p style={styles.sub}>RMcManus Holdings LLC</p>

        <form onSubmit={handleSubmit} style={{ width: '100%' }}>
          <input
            style={styles.input}
            type="email"
            placeholder="Email"
            autoComplete="email"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
          />

          <div style={styles.pwWrap}>
            <input
              style={{ ...styles.input, marginBottom: 0, paddingRight: 48 }}
              type={showPw ? 'text' : 'password'}
              placeholder="Password"
              autoComplete="current-password"
              required
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
            <button
              type="button"
              style={styles.togglePw}
              onClick={() => setShowPw(v => !v)}
              aria-label="Toggle password visibility"
            >
              {showPw ? '🙈' : '👁'}
            </button>
          </div>

          {error && <p style={styles.errorMsg}>{error}</p>}

          <button type="submit" style={styles.submitBtn} disabled={loading}>
            {loading ? 'Verifying…' : 'Sign In'}
          </button>
        </form>
      </div>

      <p style={styles.footer}>Private access only · RMcManus Holdings LLC</p>
    </div>
  );
}

const styles = {
  body: {
    background: '#060d18',
    color: '#e8edf5',
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
    minHeight: '100dvh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
  },
  card: {
    width: '100%',
    maxWidth: 380,
    background: '#0d1220',
    border: '1px solid #1e2a3a',
    borderRadius: 20,
    padding: '40px 32px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 10,
  },
  icon: { fontSize: 40, marginBottom: 4 },
  h1: {
    fontSize: 20,
    fontWeight: 700,
    color: '#f0f4ff',
    letterSpacing: '-0.4px',
    textAlign: 'center',
    margin: 0,
  },
  sub: {
    fontSize: 13,
    color: '#4a5568',
    marginBottom: 12,
    textAlign: 'center',
    margin: 0,
  },
  input: {
    width: '100%',
    padding: '14px 16px',
    background: '#0d1824',
    border: '1px solid #2a3a4a',
    borderRadius: 12,
    color: '#e8edf5',
    fontSize: 16,
    fontFamily: 'inherit',
    outline: 'none',
    WebkitAppearance: 'none',
    appearance: 'none',
    marginBottom: 10,
    boxSizing: 'border-box',
    display: 'block',
  },
  pwWrap: { position: 'relative', width: '100%', marginBottom: 10 },
  togglePw: {
    position: 'absolute',
    right: 12,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#4a5568',
    fontSize: 18,
    padding: 4,
    lineHeight: 1,
  },
  errorMsg: {
    fontSize: 13,
    color: '#f1948a',
    textAlign: 'center',
    margin: '0 0 8px',
    padding: 0,
  },
  submitBtn: {
    width: '100%',
    padding: 15,
    minHeight: 50,
    background: '#2a5280',
    border: 'none',
    borderRadius: 12,
    color: '#fff',
    fontSize: 16,
    fontWeight: 600,
    fontFamily: 'inherit',
    cursor: 'pointer',
    marginTop: 4,
    WebkitAppearance: 'none',
    opacity: 1,
  },
  footer: {
    fontSize: 11,
    color: '#1e2a3a',
    marginTop: 24,
    textAlign: 'center',
  },
};
